/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

const msInSecond = 1000;
const msInMinute = 60 * msInSecond;
const msInHour = 60 * msInMinute;
const msInDay = 24 * msInHour;

export enum TimeUnitsInMs {
    Second = msInSecond,
    Minute = msInMinute,
    Hour = msInHour,
    Day = msInDay,
}
